<template>
  <div>
   <div class="proptable" :class="fieldDragging ? 'text' : '' ">
    <table width="100%" border="0" class="dense_table">
      <thead>
        <th id="" width="20%" v-for="(grid, index) in gridLabels" :key="index">
          {{ grid.label}}
        </th>
      </thead>
      <tbody>
        <tr v-for="(row, rIndex) in gridValues" :key="rIndex">
          <td v-for="(grid, dIndex) in gridLabels" :key="dIndex" width="20%" :style="dIndex === 0 ? 'padding:0px': 'padding:0px;border: none'">
            <template v-if="dIndex === 0">
              {{ row.name }}
            </template>
            <template v-else>
              <tr>
                <td width="60%" class="pa-1" :class="fieldDragging ? 'drop-highlight' : '' ">
                  <v-text-field  dense flat full-width v-model="row[`compValue_${dIndex}`]" solo hide-details></v-text-field>
                </td>
                <td  width="30%" class="pa-1">
                  <v-select dense flat full-width hide-details :items="inventCompItem" v-model="row[`compSelect_${dIndex}`]"></v-select>
                </td>
              </tr>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    gridLabels: {
      type: Array,
      default: () => []
    },
    gridValues: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fieldDragging: false
    }
  },
  mounted () {
    this.$root.$on('isFieldDragging', (data) => {
      this.fieldDragging = data
    })
  }
}
</script>
<style scoped>
.drop-highlight {
  background-color: #D3D3D3 !important;
  border: none !important
}
.text .v-text-field.v-text-field--solo {
   background-color: #D3D3D3 !important;
}
</style>
